import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '~/app/store'
import { isJsonString } from '~/utils'

export interface IDrawerSetting {
  isShowDrawer: boolean
}

const initialState: IDrawerSetting = isJsonString(
  localStorage.getItem('drawerSetting') as string
)
  ? JSON.parse(localStorage.getItem('drawerSetting') as string)
  : {
      isShowDrawer: false
    }

const DrawerSlice = createSlice({
  name: 'drawerSetting',
  initialState,
  reducers: {
    setDrawerSetting: (state, action: PayloadAction<IDrawerSetting>) => {
      state.isShowDrawer = action.payload.isShowDrawer

      localStorage.setItem('drawerSetting', JSON.stringify(state))
    }
  }
})

export const drawerSetting = (state: RootState) => state.drawerSetting
export const setDrawerSetting = DrawerSlice.actions.setDrawerSetting

export default DrawerSlice.reducer
